/** Maps a leave-request API error `code` to the i18n key shown to the user. */
export function leaveApiErrorKey(code: string | undefined | null): string {
  switch (code) {
    case "LEAVE_TOO_LONG":
      return "leave_calendar_max_days_error";
    case "START_AFTER_END":
      return "leave_calendar_start_after_end";
    case "PAST_DATE_NOT_ALLOWED":
      return "leave_calendar_past_date_error";
    case "OVERLAPPING_LEAVE":
      return "leave_calendar_overlap_error";
    case "START_DATE_OFF_DAY":
      return "leave_calendar_start_off_day";
    case "END_DATE_OFF_DAY":
      return "leave_calendar_end_off_day";
    case "INVALID_DATE":
      return "leave_calendar_validation_required";
    case "TIMES_REQUIRED":
      return "leave_calendar_half_day_times";
    case "TEMPLATE_ID_REQUIRED":
    case "LEAVE_TEMPLATE_INVALID":
      return "leave_calendar_no_template_for_type";
    case "COMMENT_TOO_LONG":
      return "leave_calendar_comment_too_long";
    case "SUBSTITUTE_NOT_MEMBER":
      return "leave_calendar_substitute_not_member";
    default:
      return "leave_calendar_error_generic";
  }
}
